import api from '.';
import { buildParams } from '../helpers/tableUtil';

class Country {
  static async getAllRegions() {
    const regions = await api.get(`/country/regions`);
    return regions.data;
  }

  static async getCountries({ limit, page, orderData, regionFilter }) {
    const params = buildParams({ limit, page, orderData, regionFilter });
    const countries = await api.get(`/country${params}`);
    return countries.data;
  }

  static async createCountry(data) {
    const country = await api.post('/country', data);
    return country.data;
  }

  static async getCountry(id: string) {
    const country = await api.get(`/country/${id}`);
    return country.data;
  }

  static async updateCountry(id: string, data) {
    delete data.id;
    const country = await api.put(`/country/${id}`, data);
    return country.data;
  }
}

export default Country;
